/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
export default function() {
	return [
		[ "aan de ene kant", "aan de andere kant" ], [ "enerzijds", "anderzijds" ], [ "natuurlijk", "maar" ],
		[ "niet alleen", "maar ook" ], [ "noch", "noch" ], [ "zowel", "als" ],
	];
}
